// Chiavi utilizzate per memorizzare i dati di autenticazione in localStorage
export const STORAGE_KEYS  = {
     TOKEN              : 'token'                   // JWT Token per autenticazione standard
    ,K_USER             : 'kUser'                   // ID univoco Utente (generato da database)
    ,ORIGINAL_K_USER    : 'originalKUser'           // ID univoco Utente originale (per impersonificazione)
    ,USERNAME           : 'username'                // Nome Utente usato per accedere all'applicativo
    ,FULL_NAME          : 'fullname'                // Nome completo dell'Utente
    ,PRIVILEGES         : 'privileges'              // Privilegi dell'Utente (stringa JSON) es. "{\"FLAG_ADMIN\":\"Y\"}"
};

export const OTHER_KEYS    = [
     'CLIENTE_COD'
    ,'CLIENTE_DESC'
    ,'PASSWORD_MIN_LENGTH'
    ,'FLAG_UPDATE_USERS'
    ,'FLAG_PORTFOLIO_REBUILD'
    ,'DATABASE_SERVER'
    ,'LAMBDA_ENABLED'
    ,'MAX_NUM_PIVOT'
    ,'email'
    ,'name'
    ,'family_name'
];
